import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import Dashboard from "./pages/Dashboard";
import PrivateRoute from "./pages/PrivateRoute"; 
import AdminLogin from "./pages/Login"; 
import ProfileManagement from "./pages/ProfileManagement";
import SuccessStories from "./pages/SuccessStories";
import AddProfileBtn from "./components/AddProfileBtn";
import PricingPlans from "./pages/PricingPlans";
import Footer from "./components/Footer";

const AdminApp = () => {
  return (
    <div className="app-container">
      <Routes>
        {/* Login Page Route */}
        <Route path="/login" element={<AdminLogin />} />

        {/* Other Pages */}
        <Route
          path="/*"
          element={
            <>
              <Sidebar />
              <div className="main-content">
                <Header />
                <div className="page-content">
                  <Routes>
                    <Route path="/" element={<Navigate to="/admin/login" />} />
                    <Route path="/dashboard" element={ <PrivateRoute><Dashboard /> </PrivateRoute>} />
                    <Route path="/profile-management" element={ <PrivateRoute> <PricingPlans /> </PrivateRoute>} />
                    <Route path="/success-stories" element={<PrivateRoute> <SuccessStories /> </PrivateRoute>} />
                    {/* <Route path="/pricing-plans" element={<PrivateRoute> <PricingPlans /> </PrivateRoute>} /> */}
                    <Route path="/add-profile" element={<PrivateRoute> <AddProfileBtn /> </PrivateRoute>} />
                  </Routes>
                </div>
              </div>
              <Footer />
            </>
          }
        />
      </Routes>
    </div>
  );
};

export default AdminApp;
